import {ITheme} from 'contexts/ThemeContext';
import {StyleSheet, useWindowDimensions} from 'react-native';

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 0,
    height: 4,
  },
  shadowOpacity: 0.13,
  shadowRadius: 2.62,

  elevation: 4,
};

export default (props: ITheme) => {
  return StyleSheet.create({
    calendarStyle: {
      borderRadius: 13,
    },

    calendarDayTextStyle: {
      fontSize: 16,
      ...props.typography.interRegular,
    },

    calendarSelectedDayTextStyle: {
      fontSize: 16,
      color: props.colors.white,
      ...props.typography.interRegular,
    },

    textStyle: {
      fontSize: 16,
      ...props.typography.interMedium,
    },

    buttonTextStyle: {
      fontSize: 18,
      ...props.typography.interMedium,
    },

    headerContainer: {
      alignItems: 'center',
      justifyContent: 'space-between',
      flexDirection: 'row',
      marginBottom: 15,
      gap: 20,
    },

    buttonsContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      gap: 5,
      paddingRight: 2,
    },

    singleButtonContainer: {
      backgroundColor: props.colors.dirtyWhite,
      borderRadius: 8,
      alignItems: 'center',
      justifyContent: 'center',
      height: 33,
      minWidth: 33,
      paddingHorizontal: 8,
      paddingVertical: 4,
      ...shadow,
    },

    shadowProperties: {
      overflow: 'hidden',
      paddingTop: 5,
    },

    calendarContainer: {
      marginTop: 40,
      alignSelf: 'center',
    },

    imageSize: {
      width: 15,
      height: 15,
    },

    leftArrow: {
      transform: [{rotate: '90deg'}],
    },

    rightArrow: {
      transform: [{rotate: '270deg'}],
    },
    dayCell: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingBottom: 5,
    },

    point: {
      position: 'absolute',
      width: 3,
      height: 3,
      borderRadius: 2,
      bottom: 1,
    },

    pointSelected: {
      backgroundColor: props.colors.white,
    },

    pointRegular: {
      backgroundColor: props.colors.purple(1),
    },
  });
};
